import { IconButtonProps } from '@mui/material'
import { FC, forwardRef } from 'react'
import PersonIcon from './../../assets/icons/Person.svg'
import { StyledIconButton } from './ProfileButton.styles'

export const ProfileButton: FC<IconButtonProps> = forwardRef(
    ({ children, onClick, size = 'large', disabled, ...rest }, ref) => {
        return (
            <StyledIconButton disabled={disabled} ref={ref} onClick={onClick} size={size} {...rest}>
                {children ?? <PersonIcon />}
            </StyledIconButton>
        )
    },
)
